import { Time } from '@angular/common';
export class PatientD {
  pid: number;
  f_name: string;
  l_name: string;
  dob: Date;
  gender: string;
  address: string;
  address2: string;
  city_n: string;
  state: string;
  zip: number;
  contact: number;
  email: string;
  height: string;
  weight: number;
  bp_level: string;
  med_condition: string;
  diagnosis_d: string;
  symptoms: string;
  allergy: string;
  current_med: string;
  med_intake: string;
  consulting_phy: string;
  patid: number;
  drid: number;
  aid: number;
  apdate: Date;
  followup_date: Date;
  aptime: Time;
  doc_name: string;
  schedule_stat: string;
  pat_name: string;
  cid: number;
  chkpat: number;
  chkstatus: string;
  med_cond: string;
  symptom: string;
  treatment: string;
  ppurl: string;
  address_2: string;
  address_1: string;
  first_name: string;
  last_name: string;
  contact_no: number;
  reason: string;
  email_id: string
  cur_followdate: string;
  pre_consult_date: string;
  pre_followdate: string;
  online_checkin: any;
  endtime: any;
  aptid: string;
}
